/*
  This library contain the code needed by every single web page,
  so that it can be included in the _app.tsx file,
  and part of the initial page load for every page.

*/

export * from "./theme";
